(() => {
  'use strict';

  const privacy = (window.CortailorPrivacy = window.CortailorPrivacy || {});
  const dialog = document.querySelector('[data-cortailor-privacy-dialog]');
  const status = dialog?.querySelector('[data-cortailor-privacy-status]');
  const analyticsInput = dialog?.querySelector('[name="cortailor-privacy-analytics"]');
  const marketingInput = dialog?.querySelector('[name="cortailor-privacy-marketing"]');
  const preferencesInput = dialog?.querySelector('[name="cortailor-privacy-preferences"]');
  const saleInput = dialog?.querySelector('[name="cortailor-privacy-sale-optout"]');
  const saleRow = dialog?.querySelector('[data-cortailor-privacy-sale-row]');
  let opener = null;
  let customerPrivacy = null;

  const state = {
    ready: false,
    analytics: false,
    marketing: false,
    preferences: false,
    saleOfData: false,
    saleOfDataRegion: false,
    gpc: false,
  };

  const announce = (message) => {
    if (status) status.textContent = message;
  };

  const processingAllowed = (method) => {
    try {
      return Boolean(customerPrivacy && typeof customerPrivacy[method] === 'function' && customerPrivacy[method]());
    } catch (_) {
      return false;
    }
  };

  const refreshState = () => {
    state.ready = Boolean(customerPrivacy);
    state.analytics = processingAllowed('analyticsProcessingAllowed');
    state.marketing = processingAllowed('marketingAllowed');
    state.preferences = processingAllowed('preferencesProcessingAllowed');
    // Shopify honors GPC in configured sale/share regions. Keep theme-level sharing disabled
    // whenever a browser sends the signal, even while the Customer Privacy API refreshes.
    state.gpc = navigator.globalPrivacyControl === true;
    state.saleOfData = !state.gpc && processingAllowed('saleOfDataAllowed');
    state.saleOfDataRegion = Boolean(customerPrivacy && typeof customerPrivacy.saleOfDataRegion === 'function' && customerPrivacy.saleOfDataRegion());

    if (analyticsInput) analyticsInput.checked = state.analytics;
    if (marketingInput) marketingInput.checked = state.marketing;
    if (preferencesInput) preferencesInput.checked = state.preferences;
    if (saleInput) {
      saleInput.checked = (state.saleOfDataRegion && !state.saleOfData) || state.gpc;
      saleInput.disabled = state.gpc;
    }
    if (saleRow) saleRow.hidden = !state.saleOfDataRegion;

    updateGoogleConsent();
    window.dispatchEvent(new CustomEvent('cortailor:privacy-consent-changed', { detail: { ...state } }));
  };

  privacy.canUseAnalytics = () => Boolean(state.ready && state.analytics);
  privacy.canUseAdvertising = () => Boolean(state.ready && state.marketing && state.saleOfData);
  privacy.canShareData = () => Boolean(state.ready && state.saleOfData);
  privacy.getState = () => ({ ...state });

  const updateGoogleConsent = () => {
    if (typeof window.gtag !== 'function') return;

    const analytics = state.analytics ? 'granted' : 'denied';
    const advertising = state.marketing && state.saleOfData ? 'granted' : 'denied';
    const preferences = state.preferences ? 'granted' : 'denied';

    window.gtag('consent', 'update', {
      analytics_storage: analytics,
      ad_storage: advertising,
      ad_user_data: advertising,
      ad_personalization: advertising,
      functionality_storage: preferences,
      personalization_storage: preferences,
    });
  };

  const applyConsent = (values, successMessage) => {
    if (!customerPrivacy || typeof customerPrivacy.setTrackingConsent !== 'function') {
      announce('Privacy settings are not available. Please try again or use the Shopify privacy controls configured for this store.');
      return;
    }

    customerPrivacy.setTrackingConsent(values, (result) => {
      if (result?.error) {
        announce('Your privacy settings could not be saved. Please try again.');
        return;
      }
      refreshState();
      announce(successMessage);
    });
  };

  const openDialog = (trigger) => {
    if (!dialog) return;
    opener = trigger instanceof HTMLElement ? trigger : document.activeElement;
    refreshState();
    if (!dialog.open) dialog.showModal();
  };

  const closeDialog = () => {
    if (dialog?.open) dialog.close();
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-cortailor-privacy-open]');
    if (openButton) {
      event.preventDefault();
      openDialog(openButton);
      return;
    }

    const saleButton = event.target.closest('[data-cortailor-sale-optout]');
    if (saleButton) {
      event.preventDefault();
      openDialog(saleButton);
      applyConsent({ sale_of_data: false }, 'Your request not to sell or share personal information has been recorded by Shopify.');
    }
  });

  dialog?.addEventListener('click', (event) => {
    if (event.target.closest('[data-cortailor-privacy-close]')) closeDialog();

    if (event.target.closest('[data-cortailor-privacy-accept]')) {
      applyConsent(
        { analytics: true, marketing: true, preferences: true },
        'Your selected privacy settings have been saved.'
      );
    }

    if (event.target.closest('[data-cortailor-privacy-reject]')) {
      applyConsent(
        { analytics: false, marketing: false, preferences: false },
        'Non-essential privacy settings have been declined.'
      );
    }

    if (event.target.closest('[data-cortailor-privacy-save]')) {
      const values = {
        analytics: Boolean(analyticsInput?.checked),
        marketing: Boolean(marketingInput?.checked),
        preferences: Boolean(preferencesInput?.checked),
      };
      if (saleInput?.checked && !state.gpc) values.sale_of_data = false;
      applyConsent(values, 'Your selected privacy settings have been saved.');
    }
  });

  dialog?.addEventListener('close', () => {
    if (opener instanceof HTMLElement) opener.focus();
    opener = null;
  });

  document.addEventListener('visitorConsentCollected', refreshState);

  const loadCustomerPrivacy = () => {
    if (!window.Shopify?.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error || !window.Shopify?.customerPrivacy) return;
      customerPrivacy = window.Shopify.customerPrivacy;
      refreshState();
    });
  };

  document.addEventListener('shopifyCustomerPrivacyApiLoaded', loadCustomerPrivacy, { once: true });
  loadCustomerPrivacy();
})();
